import { createSelector } from 'reselect';

const selectHandHeldNumber = (state) => state.setup_advanced_user_hand_held_number;

export const selectHandHeldNumbers = createSelector(
  [selectHandHeldNumber],
  (handHeldNumber) => handHeldNumber.hand_held_number,
);
